import type { AxlesData } from './AxleInformationFields';

export const TractorFieldNames = {
  TractorId: 'tractorId',
  TractorUnitNumber: 'tractorUnitNumber',
  TractorMake: 'tractorMake',
  TractorYear: 'tractorYear',
  TractorVIN: 'tractorVIN',
  TractorModelNumber: 'tractorModelNumber',
  TractorType: 'tractorType',
  TractorFuelType: 'tractorFuelType',
  TractorBodyStyle: 'tractorBodyStyle',
  TractorAxleCount: 'tractorAxleCount',
  TractorWidth: 'tractorWidth',
  TractorHeight: 'tractorHeight',
  TractorLength: 'tractorLength',
  TractorWheelBase: 'tractorWheelBase',
  TractorGroundHeight: 'tractorGroundHeight',
  TractorUnladenWeight: 'tractorUnladenWeight',
  TractorActualWeight: 'tractorActualWeight',
  TractorGVW: 'tractorGVW',
  TractorOuterBridgeLength: 'tractorOuterBridgeLength',
  TractorLicenseEffectiveDate: 'tractorLicenseEffectiveDate',
  TractorLicensePlateYear: 'tractorLicensePlateYear',
  TractorLicensePlateType: 'tractorLicensePlateType',
  TractorLicenseExpirationDate: 'tractorLicenseExpirationDate',
  TractorLicenseIsApportionedPlate: 'tractorLicenseIsApportionedPlate',
  VehicleOfSpecialDesign: 'vehicleOfSpecialDesign',
  TractorLicensePlateNumber: 'tractorLicensePlateNumber',
  TractorLicensePlateState: 'tractorLicensePlateState',
  TractorFloridaVehicleConfiguration: 'tractorFloridaVehicleConfiguration',
  TractorOntarioVehicleType: 'tractorOntarioVehicleType',
  TractorLegalWeight: 'tractorLegalWeight',
  TractorIsLeased: 'tractorIsLeased',
  TractorOwnerName: 'tractorOwnerName',
  OwnerCompanyName: 'ownerCompanyName',
  USDOTNumberOfOwningCompany: 'USDOTNumberOfOwningCompany',
  OwnerAddress: 'ownerAddress',
  OwnerCity: 'ownerCity',
  OwnerState: 'ownerState',
  OwnerZipCode: 'ownerZipCode',
  OwnerPhone: 'ownerPhone',
  OwnerEmail: 'ownerEmail',
} as const;

export type TractorData = {
  [TractorFieldNames.TractorId]?: string;
  [TractorFieldNames.TractorUnitNumber]?: string;
  [TractorFieldNames.TractorMake]?: string;
  [TractorFieldNames.TractorYear]?: number;
  [TractorFieldNames.TractorVIN]?: string;
  [TractorFieldNames.TractorModelNumber]?: string;
  [TractorFieldNames.TractorType]?: string;
  [TractorFieldNames.TractorFuelType]?: string;
  [TractorFieldNames.TractorBodyStyle]?: string;
  [TractorFieldNames.TractorAxleCount]?: string;
  [TractorFieldNames.TractorWidth]?: number;
  [TractorFieldNames.TractorHeight]?: number;
  [TractorFieldNames.TractorLength]?: number;
  [TractorFieldNames.TractorWheelBase]?: number;
  [TractorFieldNames.TractorGroundHeight]?: number;
  [TractorFieldNames.TractorUnladenWeight]?: number;
  [TractorFieldNames.TractorActualWeight]?: number;
  [TractorFieldNames.TractorGVW]?: number;
  [TractorFieldNames.TractorOuterBridgeLength]?: number;
  [TractorFieldNames.TractorLicenseEffectiveDate]?: string;
  [TractorFieldNames.TractorLicensePlateYear]?: number;
  [TractorFieldNames.TractorLicensePlateType]?: string;
  [TractorFieldNames.TractorLicenseExpirationDate]?: string;
  [TractorFieldNames.TractorLicenseIsApportionedPlate]?: boolean;
  [TractorFieldNames.VehicleOfSpecialDesign]?: boolean;
  [TractorFieldNames.TractorLicensePlateNumber]?: string;
  [TractorFieldNames.TractorLicensePlateState]?: string;
  [TractorFieldNames.TractorFloridaVehicleConfiguration]?: string;
  [TractorFieldNames.TractorOntarioVehicleType]?: string;
  [TractorFieldNames.TractorLegalWeight]?: boolean;
  [TractorFieldNames.TractorIsLeased]?: boolean;
  [TractorFieldNames.TractorOwnerName]?: string;
  [TractorFieldNames.OwnerCompanyName]?: string;
  [TractorFieldNames.USDOTNumberOfOwningCompany]?: string;
  [TractorFieldNames.OwnerAddress]?: string;
  [TractorFieldNames.OwnerCity]?: string;
  [TractorFieldNames.OwnerState]?: string;
  [TractorFieldNames.OwnerZipCode]?: string;
  [TractorFieldNames.OwnerPhone]?: string;
  [TractorFieldNames.OwnerEmail]?: string;
};

export const TractorAxlesFormName = 'tractorAxles';
export type TractorInformationFields = {
  tractor?: TractorData;
  [TractorAxlesFormName]?: AxlesData;
};

export const TractorFields: string[] = Object.values(TractorFieldNames);
